import { render, staticRenderFns } from "./ProductOrderSchPanel.vue?vue&type=template&id=87c6d3dc&scoped=true&"
import script from "./ProductOrderSchPanel.vue?vue&type=script&lang=js&"
export * from "./ProductOrderSchPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c6d3dc",
  null
  
)

export default component.exports